import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyArPIwo67xa-WiBjPvmrycgo1ZvuWNDVbY",
  authDomain: "sandwiches-romaa.firebaseapp.com",
  projectId: "sandwiches-romaa",
  storageBucket: "sandwiches-romaa.appspot.com",
  messagingSenderId: "608821622024",
  appId: "1:608821622024:web:e242ee307df62fff36a8bd"
};

const app = initializeApp(firebaseConfig);
export const db = getFirestore(app);